import { render } from "./CourseListingComponent.vue?vue&type=template&id=08dddc00"
import script from "./CourseListingComponent.vue?vue&type=script&lang=js"
export * from "./CourseListingComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__